// removed by extract-text-webpack-plugin
module.exports = {"Navitem":"NavItem__Navitem__3GOZn","active":"NavItem__active__2ZZNc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavItems/NavItem/NavItem.css
// module id = 69
// module chunks = 3